<template lang="html">
  <div class="">
    <div class="page-drawer">      
      <div class="content-box">
          <div class="search-content">
              <div class="search-content-fields">
                  <el-form ref='searchForm' inline>
                    <el-form-item label="中文名称">
                        <el-input v-model="searchData.itemText"></el-input>
                    </el-form-item>
                    <el-form-item label="英文名称">
                        <el-input v-model="searchData.itemTextEn"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                      <el-select placeholder="请选择" v-model="searchData.status">
                          <el-option label="正常" value="1"></el-option>
                          <el-option label="禁用" value="0"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="handleSearch">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" plain @click="handleResetSearchField" >重置</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" plain @click="handleAddNewClick" >添加</el-button>
                    </el-form-item>
                  </el-form>                
              </div>
          </div>
          <div class="search-result">   
            <common-crud ref="crud"
              :addNewOrEditData="addNewOrEditData"
              :searchData="searchData"
              :crudApi="crudApi"
              :tableData.sync="dictItemData"
              :beforeSave="beforeSave"
              addSuccessMessages="添加数据字典项成功"
              editSuccessMessages="编辑数据字典项成功"
              deleteSuccessMessages="删除数据字典项成功"
              deleteBatchSuccessMessages="批量删除数据字典项成功"
            >
              <template slot="result">
                <el-table-column sortable prop="itemText" label="中文名称">
                </el-table-column>
                <el-table-column sortable prop="itemTextEn" label="英文名称">
                </el-table-column>
                <el-table-column sortable prop="itemAbbreviation" label="缩写">
                </el-table-column>
                <el-table-column sortable prop="itemValue" label="数据值">  
                </el-table-column>
                <el-table-column :formatter="formatStatusData" sortable prop="status" label="状态">  
                </el-table-column>
                <el-table-column fixed="right" label="操作">
                  <template slot-scope="scope">
                    <div class="table-column-operate">
                      <el-button type="text" @click="handleEditDictItemClick(scope.row)">
                        编辑
                      </el-button>
                      <el-button type="text" @click="handleDeleteClick(scope.row)">
                        删除
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </template> 
              <template slot="editForm">
                <el-row>
                  <el-col>
                    <el-form-item required prop="itemText" label="中文名称">
                      <el-input type="text" v-model="addNewOrEditData.itemText" placeholder="请输入中文名称"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="英文名称">
                      <el-input type="text" v-model="addNewOrEditData.itemTextEn" placeholder="请输入英文名称"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required prop="itemValue" label="数据值">
                      <el-input type="text" v-model="addNewOrEditData.itemValue" placeholder="请输入数据值"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="缩写">
                      <el-input type="text" v-model="addNewOrEditData.itemAbbreviation" placeholder="请输入缩写"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required prop="sortOrder" label="排序值">
                      <el-input type="number" v-model="addNewOrEditData.sortOrder" placeholder="值越小越靠前，支持小数"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item required prop="status" label="是否启用">
                    <el-switch
                        v-model="addNewOrEditData.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <div class="col-full">
                    <el-form-item label="描述">
                      <el-input type="text" v-model="addNewOrEditData.description" placeholder="请输入描述"></el-input>
                    </el-form-item>
                  </div>
                </el-row>
              </template> 
              <template slot="confirmAddNewMessage">
                <div>
                  <span>确认添加？</span>
                </div>
              </template>
              <template slot="confirmEditMessage">
                <div>
                  <span>确认保存？</span>
                </div>
              </template>
              <template slot="confirmDeleteMessage">
                <div>
                  <span>删除字典项？</span>
                </div>
              </template>
            </common-crud>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import dictitem from '@/api/sysmanagement/dictitem';

export default {
  props: {
    'dictId': {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dictItemData : [],
      searchData: {
        itemText:'',
        itemTextEn:'',
        status: ''
      },
      addNewOrEditData: {
        itemText: '',
        itemTextEn: '',
        itemValue: '',
        itemAbbreviation: '',
        description: '',
        sortOrder: '',
        status: true,
      },
      crudApi: dictitem,
    }
  },
  methods: {
    formatStatusData(row, column, cellValue, index) {
      return  row.status == '1'?'正常':'禁用'
    },
    handleResetSearchField() {
      this.searchData.itemText = ''
      this.searchData.itemTextEn = ''
      this.searchData.status = ''
      this.handleSearch();      
    },
    handleSearch() {
      this.searchData['dictId'] = this.dictId;
      this.$refs['crud'].handleSearch(1);   
    },
    handleAddNewClick() {
      this.$refs['crud'].handleAddNew({status: true});
    },
    handleEditDictItemClick(item) {
      this.$refs['crud'].handleEdit(item, {status: item.status? true : false});
    },
    beforeSave(saveData) {
      saveData.status = saveData.status? 1 : 0;
      saveData.dictId = this.dictId;
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
  }
};
</script>

<style lang="less" scoped>
  .page-drawer {
    width: 820px;
    height: 800px;
    overflow-y: auto;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }

  .search-content {
    display: flex;

    .search-content-fields {
      width: 800px;
    }
  }
  .operate {
    float: right;
  }
  .search-result {
    margin-top:62px
  }
</style>



// WEBPACK FOOTER //
// dictitem.vue?9fce2946